import { render, staticRenderFns } from "./MetalBimList.vue?vue&type=template&id=ad8765b8&scoped=true"
import script from "./MetalBimList.vue?vue&type=script&lang=js"
export * from "./MetalBimList.vue?vue&type=script&lang=js"
import style0 from "./MetalBimList.vue?vue&type=style&index=0&id=ad8765b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8765b8",
  null
  
)

export default component.exports